import { render, staticRenderFns } from "./UpdatesStatus.vue?vue&type=template&id=4fc1bd25&"
import script from "./UpdatesStatus.vue?vue&type=script&lang=js&"
export * from "./UpdatesStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports